import { IonButton, IonImg, IonLabel } from "@ionic/react";
import * as constants from "../../../constants";
import React from "react";
import {
	ADD,
	ESTIMATED_COST,
	RECOMMENDED,
	SERVICE_ALREADY_ADDED,
} from "../../../constants";
import { saveWorkshopStandard } from "../../../Store/Actions";
import AddOnModal from "../../../utils/addOnModal";
import { ToastMessage } from "../../../utils/toastMessage";
import { analytics } from "ionicons/icons";

export const ServicePill: React.FC = (props: any) => {
	const {
		service = {},
		pricing = {},
		addOnSections = [],
		serviceProviderWorkshopList = [],
		cssClass = "",
	} = props;
	const { displayName, shortDescription, displayTags, promotionalText } = service;
	const { amount } = pricing;
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [oilGrade, setOilGrade] = React.useState<any>({});
	const [showAddon, setShowAddon] = React.useState(false);
	const [selectedAddons, setSelectedAddons] = React.useState<any>([]);

	const addToCart = async () => {
		if (
			!(props.userAddressList || []).length &&
			(props.globalSettings || []).length &&
			props.globalSettings[0].workshopListingModel !== "Segment"
		) {
			setToast({
				showToast: true,
				toastMessage: "Please add address before booking",
				severity: "warning",
			});
			return;
		}

		if (!props.service_data.length) {
			(props.globalSettings || []).length &&
			props.globalSettings[0].workshopListingModel === "Segment"
				? props.history.push({
						pathname: "/portal/workshop-quality",
						state: {
							addOn:
								selectedAddons.length || Object.keys(oilGrade).length
									? [...selectedAddons, oilGrade]
									: [],
							pricing: pricing,
							service: service,
							serviceProviderWorkshopList: serviceProviderWorkshopList,
							workshopQuality: pricing,
						},
				  })
				: props.history.push({
						pathname: "/portal/select-workshop",
						state: {
							addOn:
								selectedAddons.length || Object.keys(oilGrade).length
									? [...selectedAddons, oilGrade]
									: [],
							pricing: pricing,
							service: service,
							serviceProviderWorkshopList: serviceProviderWorkshopList,
							workshopQuality: pricing,
						},
				  });
		} else {
			try {
				if (
					props.service_data.map((ele: any) => ele.serviceId).includes(service.serviceId)
				) {
					throw Error(SERVICE_ALREADY_ADDED);
				}
				const payload = {
					addOnsSelected:
						selectedAddons.length || Object.keys(oilGrade).length
							? [...selectedAddons, oilGrade]
							: [],
					appliedPrice: {
						amount: amount,
						currency: pricing.currency,
						model: props.settings.pricingSegment
							? props.settings.pricingSegment
							: pricing.model,
					},
					damageTypeId: service.damageTypeId || "",
					partId: service.partId || "",
					recommended: true,
					partDisplayName: displayName,
					serviceId: service.serviceId,
					workshopId: props.service_data[0].workshopId,
					// props.globalSettings.length &&
					// props.globalSettings[0].workshopListingModel === "Segment"
					//   ? ""
					//   : props.settings.workshopId || "",
				};

				// console.log("WID Check === 108 === ", payload);
				await props.addItemToCart(payload);
				await props.getCartItemsList();
			} catch (e: any) {
				setToast({
					showToast: true,
					toastMessage: e.message,
					severity: "warning",
				});
			}
		}
	};

	const showAddonModal = () => {
		try {
			if (
				props.service_data.map((ele: any) => ele.serviceId).includes(service.serviceId)
			) {
				throw Error(SERVICE_ALREADY_ADDED);
			}
			if (addOnSections.length) {
				setShowAddon(true);
				return;
			}
			addToCart();
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};

	// const handleWorkshopQualityOrModel = () => {
	//   (props.globalSettings || []).length &&
	//   props.globalSettings[0].workshopListingModel === "Segment"
	//     ? props.history.push({
	//         pathname: "/portal/workshop-quality",
	//         state: {
	//           ...props.servicesDetails,
	//           workshopQuality: props.servicesDetails.pricing,
	//           addOn:
	//             props.servicesDetails.addOnSections.length &&
	//             props.servicesDetails.addOnSections.every(
	//               (ele: any) => ele.items.length > 0
	//             )
	//               ? [...selectedAddons, oilGrade]
	//               : [],
	//         },
	//         fromServiceDetail: true,
	//       })
	//     : props.history.push({
	//         pathname: "/portal/select-workshop",
	//         state: {
	//           ...props.servicesDetails,
	//           workshopQuality: props.servicesDetails.pricing,
	//           addOn:
	//             props.servicesDetails.addOnSections.length &&
	//             props.servicesDetails.addOnSections.every(
	//               (ele: any) => ele.items.length > 0
	//             )
	//               ? [...selectedAddons, oilGrade]
	//               : [],
	//         },
	//       });
	// };

	return (
		<div className="rec_ser_prnt width_99per last_ele service_pill all_10">
			<div className="recomended_div">
				<IonLabel className="rec_recom">{RECOMMENDED}</IonLabel>
			</div>
			<div
				className="rec_ser_img_div align_start"
				onClick={async () => {
					props.location.pathname.includes("/portal/service_details") &&
						(await props.saveWorkshopStandard(pricing.model));
					await props.history.push({
						pathname: "/portal/service_details",
						state: {
							service: service,
							pricing: pricing,
							addOnSections: addOnSections,
							serviceProviderWorkshopList: serviceProviderWorkshopList,
						},
					});
				}}
			>
				<img
					src={service.imageUrl || "/images/brake_image.svg"}
					className="rec_ser_image"
				/>
				<div className="rec_row_wrap">
					<div className="tag_desc">
						<IonLabel className="rec_ser_problem service_desc">{displayName}</IonLabel>
						<IonLabel className="rec_ser_sub service_desc">{shortDescription}</IonLabel>
					</div>
					<div className="rec_ser_fea_div">
						{(displayTags || []).map((head: any, ind: any) => (
							<div key={head} className="rec_ser_feature">
								<IonLabel className="rec_ser_sub capitalize">{head}</IonLabel>
							</div>
						))}
					</div>
				</div>
				<div className={`rec_ser_price_div ${cssClass}`}>
					<IonLabel className="rec_ser_sub">{ESTIMATED_COST}</IonLabel>
					<IonLabel className="rec_ser_price" color="secondary">
						{" "}
						{constants.RupeeSymbol}
						{` ${Number(amount)}`}
					</IonLabel>
				</div>
			</div>
			<div className="dashed_line_btn">
				<div className="rec_flex_col">
					{!!promotionalText && (
						<div className="offer_text">
							<hr className="dotted_line" />
							<div className="rec_flex_row_center">
								<img className="save_per_img" src="/images/save_per.svg" />
								<IonLabel className="rec_ser_sub">{promotionalText}</IonLabel>
							</div>
						</div>
					)}
					<div className="rec_ser_fea_div_mobile">
						{(displayTags || []).map((head: any, ind: any) => (
							<div key={head} className="rec_ser_feature">
								<IonLabel className="rec_ser_sub">{head}</IonLabel>
							</div>
						))}
					</div>
				</div>
				<IonButton
					className="rec_ser_add_btn"
					onClick={() => {
						showAddonModal();
					}}
				>
					<IonLabel color="light" className="add_btn_style">
						{ADD}
					</IonLabel>
				</IonButton>
			</div>

			<AddOnModal
				restoreState={() => {
					setSelectedAddons([]);
					setOilGrade({});
				}}
				showAddon={showAddon}
				oilGrade={oilGrade}
				selectedAddons={selectedAddons}
				setShowAddon={(value: boolean) => setShowAddon(value)}
				addOnSections={addOnSections}
				setOilGrade={(value: any) => {
					if (value.addOnId !== oilGrade.addOnId) {
						setOilGrade(value);
					} else {
						setOilGrade({});
					}
				}}
				setSelectedAddons={(value: any) => {
					const index = selectedAddons.findIndex(
						(ele: any) => ele.addOnId === value.addOnId
					);
					if (index < 0) {
						setSelectedAddons([...selectedAddons, value]);
					} else {
						setSelectedAddons(
							selectedAddons.filter((ele: any) => ele.addOnId !== value.addOnId)
						);
					}
				}}
				submitData={() => {
					setShowAddon(false);
					addToCart();
				}}
			/>

			{!!promotionalText && (
				<div className="offer_text_mobile">
					<hr className="dotted_line" />
					<div className="rec_flex_row_center">
						<img className="save_per_img" src="/images/save_per.svg" />
						<IonLabel className="rec_ser_sub">{promotionalText}</IonLabel>
					</div>
				</div>
			)}
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
		</div>
	);
};
export default ServicePill;
